import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faPlus, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modal';
import PharmacyGardePeriodsModal from './PharmacyGardePeriodsModal';
import Form from '../Form/Form';
import InputDate from '../Form/Fields/InputDate';
import { API_BASE_URL } from '../../api';

import './CreateProductModal.scss';

export default function PharmacyGardeModal({ show, onClose, onSaved, pharmacy }) {
    const [formKey, setFormKey] = useState(0);
    const [showPeriods, setShowPeriods] = useState(false);

    const onSubmit = (data) => {
        if (!data.startDate || !data.endDate) {
            toast.error('Veuillez renseigner les deux dates.');
            return;
        }
        if (new Date(data.endDate) <= new Date(data.startDate)) {
            toast.error('La date de fin doit être après la date de début.');
            return;
        }
        axios
            .post(`${API_BASE_URL}/api/v1/pharmacies/${pharmacy.id}/garde`, data, { withCredentials: true })
            .then(() => {
                setFormKey((k) => k + 1);
                toast.success('Période de garde ajoutée.');
                onSaved?.();
                onClose();
            })
            .catch(() => toast.error('Une erreur est survenue.'));
    };

    return (
        <>
            <Modal
                title={pharmacy ? `Garde — ${pharmacy.name}` : 'Garde'}
                show={show}
                onClose={onClose}
                icon={faClock}
                iconBg="#fff7ed"
                iconColor="#f59e0b"
                footer={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <button type="button" className="btn btn-link btn-sm px-0" onClick={() => setShowPeriods(true)}>
                            <FontAwesomeIcon icon={faCalendarDays} className="me-2" />
                            Voir les périodes
                        </button>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <button type="button" className="btn btn-light btn-sm" onClick={onClose}>
                                Fermer
                            </button>
                            <button type="submit" form="gardeForm" className="modal-btn-primary">
                                <FontAwesomeIcon icon={faPlus} className="me-2" />
                                Ajouter la période
                            </button>
                        </div>
                    </div>
                }
            >
                <Form id="gardeForm" key={formKey} onSubmit={onSubmit} defaultValues={{ startDate: '', endDate: '' }}>
                    <div className="cdm-section" style={{ marginBottom: 0 }}>
                        <p className="cdm-section__label">Nouvelle période</p>
                        <div className="cdm-grid-2">
                            <div>
                                <label className="cdm-field-label">Du <span className="text-danger">*</span></label>
                                <InputDate name="startDate" mode="datetime" validationRules={{ required: true }} />
                            </div>
                            <div>
                                <label className="cdm-field-label">Au <span className="text-danger">*</span></label>
                                <InputDate name="endDate" mode="datetime" validationRules={{ required: true }} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Modal>

            <PharmacyGardePeriodsModal
                show={showPeriods}
                onClose={() => setShowPeriods(false)}
                pharmacy={pharmacy}
            />
        </>
    );
}
